<div class="modal-container" data-cy="native-optional-update-modal">
  <div class="close-modal" (click)="closeModal()" data-cy="native-optional-update-dismiss-btn">
    <img src="assets/icon/blue-close.svg" alt="" />
  </div>

  <img src="assets/imgs/happy-bean.svg" alt="" class="bean"/>

  <div class="title">{{ 'PWA_Update_popup_header' | translate }}</div>
  <div class="description">{{ 'PWA_Update_popup_body' | translate }}</div>

  <app-button [bold]="true" [label]="'PWA_Update_popup_CTA_updateNow' | translate" (clicked)="updateApp()" />
</div>
